import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { useAuth } from '@/hooks/useAuth';
import { apiClient } from '@/services/api';
import { USER_ROLES } from '@/constants';
import styles from './styles.module.scss';

const DebugModeIndicator: React.FC = () => {
  const { user } = useAuth();

  const { data: debugMode } = useQuery({
    queryKey: ['debug-mode'],
    queryFn: async () => {
      const response = await apiClient.getDebugMode();
      return response.data?.data;
    },
    refetchInterval: 30000,
    staleTime: 10000,
    enabled: user?.role === USER_ROLES.ADMIN,
  });

  if (user?.role !== USER_ROLES.ADMIN) {
    return null;
  }

  if (!debugMode?.predictions_debug_mode) {
    return null;
  }

  return (
    <div className={styles.container}>
      <div className={styles.badge}>
        🔧 DEBUG MODE
      </div>
    </div>
  );
};

export default DebugModeIndicator;
